import {
  createFeatureSelector,
  MemoizedSelector
} from '@ngrx/store';
import {
  OrganizationState,
  ORGANIZATION_FEATURE,
  StateWithOrganization
} from '@spartacus/organization/administration/core';

export const getOrganizationState: MemoizedSelector<
  StateWithOrganization,
  OrganizationState
> = createFeatureSelector<OrganizationState>(ORGANIZATION_FEATURE);
